<template>
 <br/>
 <van-notice-bar
    wrapable :scrollable="false" color="#1989fa" background="#ecf9ff"
                left-icon="volume-o">
              <p class="text2Indentation">默认会显示上次输入数据，您可以直接进行修订</p>
  </van-notice-bar>
  <br/>
  <van-cell-group inset>
    <van-notice-bar
    wrapable :scrollable="false" 
                left-icon="shield-o">
              <p class="text2Indentation">血压数据</p>
            </van-notice-bar>
    <van-row>
      <van-space :size="5">
          <van-col span="16"><van-field v-model="userDataHandVo.systolicBloodPressure" type="digit" label="收缩压值" placeholder="请输入数字"/></van-col>
          <van-col span="4"><p>mmHg</p></van-col>
          <van-col span="4"><van-icon name="info-o" @click="showSQue"/></van-col>
      </van-space>
    </van-row>
    <van-row>
      <van-space :size="5">
          <van-col span="16"><van-field v-model="userDataHandVo.diastolicBloodPressure" type="digit" label="舒张压值" placeholder="请输入数字" /></van-col>
          <van-col span="4"><p>mmHg</p></van-col>
          <van-col span="4"><van-icon name="info-o" @click="showDQue"/></van-col>
      </van-space>
    </van-row>
    <van-field
      v-model="result"
      is-link
      readonly
      name="datePicker"
      label="检查时间"
      placeholder="点击选择时间"
      @click="showPicker = true"
      />
    <van-popup v-model:show="showPicker" position="bottom">
        <van-date-picker  v-model="currentDate"
                :min-date="minDate"
                :max-date="maxDate" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
</van-cell-group>
<br/>
<van-cell-group inset>
    <van-notice-bar
    wrapable :scrollable="false" 
                left-icon="bar-chart-o">
              <p class="text2Indentation">血脂4项数据(门诊检查"血脂4项"或体检中通常会包含)</p>
            </van-notice-bar>
    <van-row>
      <van-space :size="5">
          <van-col span="16"><van-field v-model="userDataHandVo.tc" label="总胆固醇(TC)"  placeholder="请输入数字" /></van-col>
          <van-col span="4"><p>mmol/L</p></van-col>
          <van-col span="4"><van-icon name="info-o" @click="showTCQue"/></van-col>
      </van-space>
    </van-row>
    <van-row>
      <van-space :size="5">
          <van-col span="16"><van-field v-model="userDataHandVo.tg"  label="甘油三酯(TG)" placeholder="请输入数字" /></van-col>
          <van-col span="4"><p>mmol/L</p></van-col>
          <van-col span="4"><van-icon name="info-o" @click="showTGQue"/></van-col>
      </van-space>
    </van-row>
    <van-row>
      <van-space :size="5">
          <van-col span="16"><van-field v-model="userDataHandVo.hdlC"  label="高密度胆固醇(HDL-C)" placeholder="请输入数字" /></van-col>
          <van-col span="4"><p>mmol/L</p></van-col>
          <van-col span="4"><van-icon name="info-o" @click="showHDLQue"/></van-col>
      </van-space>
    </van-row>
    <van-row>
      <van-space :size="5">
          <van-col span="16"><van-field v-model="userDataHandVo.ldlC" label="低密度胆固醇(LDL-C)" placeholder="请输入数字" /></van-col>
          <van-col span="4"><p>mmol/L</p></van-col>
          <van-col span="4"><van-icon name="info-o" @click="showLDLQue"/></van-col>
      </van-space>
    </van-row>
    <van-field
      v-model="result2"
      is-link
      readonly
      name="datePicker"
      label="检查时间"
      placeholder="点击选择时间"
      @click="showPicker2 = true"
      />
    <van-popup v-model:show="showPicker2" position="bottom">
        <van-date-picker v-model="currentDate2"
                :min-date="minDate"
                :max-date="maxDate" @confirm="onConfirm2" @cancel="showPicker2 = false" />
    </van-popup>
</van-cell-group>
<br/>
<van-button color="linear-gradient(to right, #f67f34, #d55809)" round block  @click="getUserDataSave">提交新评估</van-button>
<van-dialog v-model:show="showTC" title="总胆固醇" show-cancel-button>
  <img src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/TC.png" width="500" height="50" />
</van-dialog>
<van-dialog v-model:show="showTG" title="甘油三酯" show-cancel-button>
  <img src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/TG.png" width="500" height="50" />
</van-dialog>
<van-dialog v-model:show="showHDL" title="高密度脂蛋白胆固醇" show-cancel-button>
  <img src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/HDL-C.png" width="500" height="50" />
</van-dialog>
<van-dialog v-model:show="showLDL" title="低密度脂蛋白胆固醇" show-cancel-button>
  <img src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/LDL-C.png" width="500" height="50" />
</van-dialog>
</template>
<script>
import { ref,onMounted,reactive,toRefs} from "vue";
import { addUserBloodData,getUserBloodDataById} from '../../api/bloodData'
import { showDialog,showConfirmDialog } from 'vant';
import { useRouter } from "vue-router";
export default {
  setup() {
    const router = useRouter();
    const showTC = ref(false);
    const showTG = ref(false);
    const showHDL = ref(false);
    const showLDL = ref(false);
    const result = ref('');
    const showPicker = ref(false);
    const currentDate = ref(['2024', '02','01']);
    const currentDate2 = ref(['2024', '02','01']);
    const onConfirm = ({ selectedValues }) => {
      result.value = selectedValues.join('/');
      showPicker.value = false;
    }
    const result2 = ref('');
    const showPicker2 = ref(false);
    const onConfirm2 = ({ selectedValues }) => {
      result2.value = selectedValues.join('-');
      showPicker2.value = false;
    }
    const showSQue = () => {
      showDialog({
        message: '是血压中的最大值,收缩压通常大于90',
        theme: 'round-button',
      }).then(() => {
          // on close
      });
    }
    const showDQue = () => {
      showDialog({
        message: '是血压中的最小值',
        theme: 'round-button',
      }).then(() => {
          // on close
      });
    }
    const showTCQue = () => {
     
      showTC.value=true;
    }
    const showTGQue = () => {
     
      showTG.value=true;
    }
    const showHDLQue = () => {
      
      showHDL.value=true;
    }
    const showLDLQue = () => {
      
      showLDL.value=true;
    }
    const userData = reactive({
      userDataHandVo: {
        systolicBloodPressure: "",
        diastolicBloodPressure: "",
        pressureTime: "",
        tc: "",
        tg: "",
        hdlC: "",
        ldlC:"",
        lipidTime:"",
        handChecked:"",
      },
    });
    const getUserDataSave = () => {
      if(userData.userDataHandVo.systolicBloodPressure == "" ||
      userData.userDataHandVo.tc == "" ||
      userData.userDataHandVo.tg == "" ||
      userData.userDataHandVo.hdlC == "" ||
      userData.userDataHandVo.ldlC == "" ){
          showDialog({
            title: "错误提醒",
            message: "请填写必要的绑定信息!",
            theme: "round-button",
          }).then(() => {
            
          });
      }else{
        console.log(result);
        userData.userDataHandVo.pressureTime=result.value;
        userData.userDataHandVo.lipidTime=result2.value;
        addUserBloodData(userData.userDataHandVo).then((res) => {
          console.log(res.data.code);
          if (res.data.code == 0) {
            console.log("绑定成功");
            showDialog({
                title: "完成提交",
                theme: "round-button",
            }).then(() => {
              router.push('dataCenterList');
            });
          } else {
            if(res.data.code ==50000){
              showConfirmDialog({
                    title: '卡劵不足',
                    message:'卡包中没有可用评测卡，需要向绑定机构获取。目前未开放个人购买通道!',
              })
              .then(() => {
                router.push('userOrder');
              })
              .catch(() => {
                  // on cancel
              });
            }
          }
        });
      }
    };
    onMounted(() => {
      getUserBloodDataById().then((res) =>{
               userData.userDataHandVo=res.data.data;
               console.log(userData.userDataHandVo);
               result.value=userData.userDataHandVo.pressureTime;
               result2.value=userData.userDataHandVo.lipidTime;
               if(userData.userDataHandVo.pressureTime!=null){
                  const myArray = userData.userDataHandVo.pressureTime.split("-");
                  currentDate.value=myArray;
                }
                if(userData.userDataHandVo.lipidTime!=null){
                  const myArray = userData.userDataHandVo.lipidTime.split("-");
                  currentDate2.value=myArray;
                }
        })
    });
    return {
      showTCQue,
      showTGQue,
      showHDLQue,
      showLDLQue,
      showTC,
      showTG,
      showHDL,
      showLDL,
      showSQue,
      showDQue,
      userData,
      result,
      onConfirm,
      showPicker,
      result2,
      onConfirm2,
      showPicker2,
      currentDate,
      currentDate2,
      getUserDataSave,
      minDate: new Date(2023, 10, 1),
      maxDate: new Date(2026, 1, 1),
      ...toRefs(userData),
    };
  },
};
</script>
<style lang="less" scoped>

</style>
